import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";

import ObjectiveView from "@/modules/performance/user/components/objective/view/ObjectiveView";
import { fetchObjectiveQueryOptions } from "@/modules/performance/user/services";

const tabs = ["all", "my", "inbox", "archives"] as const;

export const Route = createFileRoute(
  "/_panel/_performance/performance/objectives/$id",
)({
  component: RouteComponent,
  validateSearch: z.object({
    tab: z.enum(tabs).default("all"),
  }),
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Objective Details", { ns: "performance.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchObjectiveQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { tab } = Route.useSearch();
  return <ObjectiveView id={id} returnTab={tab} />;
}
